// Shown while a navigation's guards run (session, memberships, node path),
// so the portal is never a blank page between routes.
import { useI18n } from "@/i18n/I18nProvider";

export function PendingScreen() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-screen items-center justify-center" role="status" aria-live="polite">
      <span className="inline-flex items-center gap-2 text-sm text-t-3">
        <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" aria-hidden />
        {t("common.loading")}
      </span>
    </div>
  );
}
